import type { FC, PropsWithChildren } from 'react';
import React from 'react';
import { match } from 'variant';
import { Spinner, useAsync } from '@wix/cli-ui-kit';
import { useTranslation } from '@wix/cli-i18n';
import { useVeloClient } from '@wix/velo-client';
import { useVeloTypesSyncClient } from '../../velo-types-sync-client/useVeloTypesSyncClient.js';
import { useProjectFilesService } from '../../project-files-service/useProjectFilesService.js';
import { useProjectModel } from '../../model.js';

export const InitializingState: FC<PropsWithChildren> = ({ children }) => {
  const { t } = useTranslation();
  const veloClient = useVeloClient();
  const projectFilesService = useProjectFilesService();
  const { veloAppId, projectFolder } = useProjectModel();
  const veloTypeSyncer = useVeloTypesSyncClient(projectFolder);

  const { status } = useAsync(async () => {
    async function initProjectFiles() {
      const { files, directories } = await veloClient.listAppFiles(veloAppId);
      await Promise.all([
        ...directories.map(projectFilesService.addDir),
        ...files.map(projectFilesService.saveFile),
      ]);
    }
    await Promise.all([initProjectFiles(), veloTypeSyncer.syncLatestTypes()]);
  }, []);

  return match(status, {
    Success: () => children,
    Error: () => null,
    Loading: () => <Spinner text={t('dev_command.init.fetching_files')} />,
  });
};
